module.exports = __webpack_public_path__ + "img/sticker_6.f78a31ed.svg";